export const SPINNER_DURATION = 9000;
export const SPINS_PER_TOKEN = 250;
